import { Injectable, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { VALIDATION_ERROR_MESSAGES } from '../../enums/form-control.enums';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ValidationMessageService {
    private readonly translate = inject(TranslateService);

    public setValidationMessage(formControlErrors: ValidationErrors | null): string {
        if (formControlErrors) {
            // If error message was created in the widget, just pass it through
            const errors = Object.keys(formControlErrors);
            if (errors.length && formControlErrors[errors[0]].text) {
                return this.translate.instant(formControlErrors[errors[0]].text);
            }

            // Forbidden characters requires the character as additional property for the translation and should be evaluated before other errors
            const forbiddenCharacterErrorIndex = errors.findIndex((errorKey) => errorKey === 'forbiddenCharacters');
            if (errors.length && forbiddenCharacterErrorIndex >= 0) {
                return this.translate.instant(
                    VALIDATION_ERROR_MESSAGES.forbiddenCharacters,
                    formControlErrors[errors[forbiddenCharacterErrorIndex]],
                );
            }

            return errors.length && VALIDATION_ERROR_MESSAGES[errors[0] as keyof typeof VALIDATION_ERROR_MESSAGES]
                ? this.translate.instant(VALIDATION_ERROR_MESSAGES[errors[0] as keyof typeof VALIDATION_ERROR_MESSAGES])
                : this.translate.instant(VALIDATION_ERROR_MESSAGES.default);
        }

        return VALIDATION_ERROR_MESSAGES.empty;
    }
}
